import { createUseStore } from "../hooks/Events";

const [useNotifications, setNotifications, setNotificationsWithPrevState] =
  createUseStore([]);

export { useNotifications, setNotifications, setNotificationsWithPrevState };
